<main id="dsgnrContent" role="main" class="dsgnr-body post-1484 page type-page status-publish hentry">

  <section class="section-layout-block section-with-card">

    <div class="container single-content-layout-layout-block mb-5">
      <div class="row justify-content-center text-center">
        <div class="column-block col-12 card-like card-like-lg text-center">

          <!-- Tabs Header -->
          <div class="wrapper bs5tabnav-block">
            <div class="container">
              <div class="row pb-4">
                <div class="col text-center">
                  <h1 class="mb-0 h4">
                    {{
                      viewType === 'Trade' ? 'Trade Request Dashboard'
                      : viewType === 'Admin' ? 'Admin Approval Dashboard'
                      : 'Sharing Request Dashboard'
                    }}
                  </h1>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <ul class="nav nav-pills mb-0">
                    <li class="nav-item">
                      <button class="bs5tabnavitem-block tabnav-inner nav-link"
                              [ngClass]="{ 'active': activeTab === 'supply' }"
                              (click)="activeTab = 'supply'; loadRequests()">
                        <p class="m-0 p-0">Providing Water</p>
                      </button>
                    </li>

                    <li class="nav-item">
                      <button class="bs5tabnavitem-block tabnav-inner nav-link"
                              [ngClass]="{ 'active': activeTab === 'demand' }"
                              (click)="activeTab = 'demand'; loadRequests()">
                        <p class="m-0 p-0">Accepting Water</p>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- TAB CONTENT -->
          <div class="wrapper">
            <div class="container">
              <div class="row py-2 justify-content-center">
                <div class="col-12">
                  <!-- SUPPLY TAB -->
                  <div *ngIf="activeTab === 'supply'" class="tab-pane active">
                    <div class="watersharing-blocks full-width">
                      <div id="loading-indicator" class="share_supply-loading-indicator"></div>

                      <form>
                        <!-- TABLE -->
                        <table class="watersharing-table tablesorter">
                          <thead>
                            <tr>
                              <th></th>
                              <th *ngIf="viewType === 'Admin'">Company</th>
                              <th *ngIf="viewType === 'Admin'">User</th>
                              <th>Pad Name</th>
                              <th>Date Range</th>
                              <th>Status</th>
                              <th>Rate (bpd)</th>
                              <th *ngIf="viewType != 'Admin'">Matches Found</th>
                              <th *ngIf="viewType === 'Admin'">Mode</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <ng-container *ngFor="let item of supplyRequests">
                              <!-- Main Row -->
                              <tr>
                                <td>
                                  <input type="checkbox"
                                         [(ngModel)]="item.selected"
                                         name="select_{{ item.recordId }}" />
                                </td>
                                <td *ngIf="viewType === 'Admin'">{{item.clientName}}</td>
                                <td *ngIf="viewType === 'Admin'">{{item.userName}}</td>
                                <td>{{item.padName}}</td>
                                <td>{{item.dateRange}}</td>
                                <td>{{item.status}}</td>
                                <td>{{item.rate}}</td>
                                <td *ngIf="viewType != 'Admin'">{{item.matches}}</td>
                                <td *ngIf="viewType === 'Admin'">{{item.mode}}</td>
                                <td class="text-center actions-cell">
                                  <div class="actions-wrapper">
                                    <!-- Toggle arrow -->
                                    <a (click)="item.matches && toggleExpand(item)"
                                       [ngClass]="{'arrow-icon': true,
                                          'disabled': item.matches === 0,
                                          'expanded': item.expanded
                                          }"
                                       title="{{ item.matches === 0 ? 'No matches available' : 'View Matches' }}">
                                      <i class="fa fa-chevron-right"></i>
                                    </a>
                                    <!-- Admin / Edit Actions -->
                                    <ng-container *ngIf="viewType === 'Admin'">
                                      <!-- Show Pending Approval for staged records -->
                                      <a *ngIf="item.status === 'staging' && !item.hasAdminApproval"
                                         (click)="adminApprove(item)"
                                         class="pending-link"
                                         title="Pending Approval">
                                        Approve Request
                                      </a>

                                      <!-- Always show Edit -->
                                      <a (click)="editRecord(item)"
                                         class="edit-link"
                                         title="Edit Request">
                                        Edit Request
                                      </a>
                                    </ng-container>

                                    <!-- Normal users get only the Edit link -->
                                    <ng-container *ngIf="viewType !== 'Admin'">
                                      <a (click)="editRecord(item)" class="edit-link" title="Edit Request">
                                        Edit
                                      </a>
                                    </ng-container>

                                  </div>
                                </td>

                              </tr>

                              <!-- Expanded Rows (one row per match) -->
                              <ng-container *ngIf="item.expanded && item.dashboardRecord">
                                <tr *ngFor="let match of item.dashboardRecord.matches">
                                  <td colspan="7">
                                    <div class="watersharing-row watersharing-match-block">

                                      <!-- LEFT: Match details -->
                                      <div class="watersharing-match-detail" style="padding-right: 10px; max-width:70%;">
                                        <div class="watersharing-row">

                                          <!-- Matched Operator + Actions -->
                                          <div class="watersharing-col watersharing-match-col">
                                            <div class="watersharing-row">
                                              <div class="watersharing-col-half">
                                                <strong>Matched Operator:</strong> {{ match.matchedClientName }}
                                              </div>
                                              <div class="watersharing-col-half">
                                                <a class="watersharing-match-action approval approve-action"
                                                   (click)="approveBid(item.dashboardRecord, match)">
                                                  <i class="fa-solid fa-thumbs-up"></i> Approve
                                                </a>
                                                <a class="watersharing-match-action approval decline-action"
                                                   (click)="rejectBid(item.dashboardRecord, match)">
                                                  <i class="fa-solid fa-thumbs-down"></i> Decline
                                                </a>
                                              </div>
                                            </div>
                                          </div>

                                          <!-- Trade mode -->
                                          <ng-container *ngIf="viewType === 'Trade'">
                                            <div class="watersharing-col-half watersharing-match-col">
                                              <strong>Total Value:</strong> {{ match.totalCost }} USD
                                            </div>
                                            <div class="watersharing-col-half watersharing-match-col">
                                              <strong>Total Volume:</strong> {{ match.totalVolume }} bbl
                                            </div>
                                          </ng-container>

                                          <!-- Share mode -->
                                          <ng-container *ngIf="viewType === 'Share'">
                                            <div class="watersharing-col-half watersharing-match-col">
                                              <strong>Dates:</strong> {{ match.dateRange }}
                                            </div>
                                            <div class="watersharing-col-half watersharing-match-col">
                                              <strong>Rate (bpd):</strong> {{ match.rateBpd }}
                                            </div>
                                            <div class="watersharing-col-half watersharing-match-col">
                                              <strong>Distance (miles):</strong> {{ match.distance }}
                                            </div>
                                            <div class="watersharing-col-half watersharing-match-col">
                                              <strong>Sourced Water Saved (bbl):</strong> {{ match.sourcedWaterSaved }}
                                            </div>
                                          </ng-container>

                                        </div>
                                      </div>

                                      <!-- RIGHT: Approval / Contact -->
                                      <div *ngIf="!match.showUserDetails" style="max-width:30%" class="watersharing-col-third watersharing-no-contact">
                                        <div class="no-contact">
                                          <span>Approval Pending</span>
                                        </div>
                                      </div>

                                      <div *ngIf="match.showUserDetails" style="max-width:30%" class="watersharing-col-third watersharing-contact">
                                        <div>
                                          <span class="heading"><strong>Contact Information</strong></span>
                                          <span style="display:block">
                                            {{ match.firstName }} {{ match.lastName }}
                                            <span><a style="display:block" href="mailto:{{ match.userEmail }}">{{ match.userEmail }}</a></span>
                                          </span>
                                        </div>
                                        <div>
                                          <button type=" "
                                                  class="watersharing-secondary-button export-button"
                                                  (click)="downloadCsv(item.dashboardRecord)">
                                            Export CSV
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </ng-container>

                            </ng-container>
                          </tbody>
                        </table>

                        <!-- Actions -->
                        <div class="table-action-row">
                          <div class="hide-on-mobile">
                            <select class="user-select select-request-action"
                                    [(ngModel)]="supplyAction"
                                    name="supply_action">
                              <option value="" disabled selected>Manage Selection</option>
                              <option value="close">Close Request(s)</option>
                              <option value="delete">Delete Request(s)</option>
                            </select>
                            <button type="button"
                                    class="watersharing-secondary-button post-status-submit"
                                    [disabled]="!enableSupplyApply"
                                    (click)="applySupplyAction()">
                              <span class="apply-text">Apply</span>
                            </button>
                          </div>
                          <div class="pagination-outer-container"></div>
                        </div>
                      </form>
                    </div>
                  </div>

                  <!-- DEMAND TAB -->
                  <div *ngIf="activeTab === 'demand'" class="tab-pane active">
                    <div class="watersharing-blocks full-width">
                      <div id="loading-indicator" class="share_demand-loading-indicator"></div>

                      <form>
                        <table class="watersharing-table tablesorter" id="demand-table">
                          <thead>
                            <tr>
                              <th></th>
                              <th *ngIf="viewType === 'Admin'">Company</th>
                              <th *ngIf="viewType === 'Admin'">User</th>
                              <th>Pad Name</th>
                              <th>Date Range</th>
                              <th>Status</th>
                              <th>Rate (bpd)</th>
                              <th *ngIf="viewType != 'Admin'">Matches Found</th>
                              <th *ngIf="viewType === 'Admin'">Mode</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <ng-container *ngFor="let item of demandRequests">
                              <!-- Main Row -->
                              <tr>
                                <td>
                                  <input type="checkbox"
                                         [(ngModel)]="item.selected"
                                         name="select_{{ item.recordId }}" />
                                </td>
                                <td *ngIf="viewType === 'Admin'">{{item.clientName}}</td>
                                <td *ngIf="viewType === 'Admin'">{{item.userName}}</td>
                                <td>{{item.padName}}</td>
                                <td>{{item.dateRange}}</td>
                                <td>{{item.status}}</td>
                                <td>{{item.rate}}</td>
                                <td *ngIf="viewType != 'Admin'">{{item.matches}}</td>
                                <td *ngIf="viewType === 'Admin'">{{item.mode}}</td>
                                <td class="text-center actions-cell">
                                  <div class="actions-wrapper">
                                    <!-- Toggle arrow -->
                                    <a (click)="item.matches && toggleExpand(item)"
                                       [ngClass]="{'arrow-icon': true,
                                          'disabled': item.matches === 0,
                                          'expanded': item.expanded
                                          }"
                                       title="{{ item.matches === 0 ? 'No matches available' : 'View Matches' }}">
                                      <i class="fa fa-chevron-right"></i>
                                    </a>
                                    <!-- Admin / Edit Actions -->
                                    <ng-container *ngIf="viewType === 'Admin'">
                                      <!-- Show Pending Approval for staged records -->
                                      <a *ngIf="item.status === 'staging' && !item.hasAdminApproval"
                                         (click)="adminApprove(item)"
                                         class="pending-link"
                                         title="Pending Approval">
                                        Approve Request
                                      </a>

                                      <!-- Always show Edit -->
                                      <a (click)="editRecord(item)"
                                         class="edit-link"
                                         title="Edit Request">
                                        Edit Request
                                      </a>
                                    </ng-container>

                                    <!-- Normal users get only the Edit link -->
                                    <ng-container *ngIf="viewType !== 'Admin'">
                                      <a (click)="editRecord(item)" class="edit-link" title="Edit Request">
                                        Edit
                                      </a>
                                    </ng-container>

                                  </div>
                                </td>

                              </tr>
                              <!-- Expanded Rows (one row per match) -->
                              <ng-container *ngIf="item.expanded && item.dashboardRecord">
                                <tr *ngFor="let match of item.dashboardRecord.matches">
                                  <td colspan="7">
                                    <div class="watersharing-row watersharing-match-block">

                                      <!-- LEFT: Match details -->
                                      <div class="watersharing-match-detail" style="padding-right: 10px; max-width:70%;">
                                        <div class="watersharing-row">

                                          <!-- Matched Operator + Actions -->
                                          <div class="watersharing-col watersharing-match-col">
                                            <div class="watersharing-row">
                                              <div class="watersharing-col-half">
                                                <strong>Matched Operator:</strong> {{ match.matchedClientName }}
                                              </div>
                                              <div class="watersharing-col-half">
                                                <a class="watersharing-match-action approval approve-action"
                                                   (click)="approveBid(item.dashboardRecord, match)">
                                                  <i class="fa-solid fa-thumbs-up"></i> Approve
                                                </a>
                                                <a class="watersharing-match-action approval decline-action"
                                                   (click)="rejectBid(item.dashboardRecord, match)">
                                                  <i class="fa-solid fa-thumbs-down"></i> Decline
                                                </a>
                                              </div>
                                            </div>
                                          </div>

                                          <!-- Trade mode -->
                                          <ng-container *ngIf="viewType === 'Trade'">
                                            <div class="watersharing-col-half watersharing-match-col">
                                              <strong>Total Value:</strong> {{ match.totalCost }} USD
                                            </div>
                                            <div class="watersharing-col-half watersharing-match-col">
                                              <strong>Total Volume:</strong> {{ match.totalVolume }} bbl
                                            </div>
                                          </ng-container>

                                          <!-- Share mode -->
                                          <ng-container *ngIf="viewType === 'Share'">
                                            <div class="watersharing-col-half watersharing-match-col">
                                              <strong>Dates:</strong> {{ match.dateRange }}
                                            </div>
                                            <div class="watersharing-col-half watersharing-match-col">
                                              <strong>Rate (bpd):</strong> {{ match.rateBpd }}
                                            </div>
                                            <div class="watersharing-col-half watersharing-match-col">
                                              <strong>Distance (miles):</strong> {{ match.distance }}
                                            </div>
                                            <div class="watersharing-col-half watersharing-match-col">
                                              <strong>Sourced Water Saved (bbl):</strong> {{ match.sourcedWaterSaved }}
                                            </div>
                                          </ng-container>

                                        </div>
                                      </div>

                                      <!-- RIGHT: Approval / Contact -->
                                      <div *ngIf="!match.showUserDetails" style="max-width:30%" class="watersharing-col-third watersharing-no-contact">
                                        <div class="no-contact">
                                          <span>Approval Pending</span>
                                        </div>
                                      </div>

                                      <div *ngIf="match.showUserDetails" style="max-width:30%" class="watersharing-col-third watersharing-contact">
                                        <div>
                                          <span class="heading"><strong>Contact Information</strong></span>
                                          <span style="display:block">
                                            {{ match.firstName }} {{ match.lastName }}
                                            <span><a style="display:block" href="mailto:{{ match.userEmail }}">{{ match.userEmail }}</a></span>
                                          </span>
                                        </div>
                                        <div>
                                          <button type=" "
                                                  class="watersharing-secondary-button export-button"
                                                  (click)="downloadCsv(item.dashboardRecord)">
                                            Export CSV
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </ng-container>

                            </ng-container>
                          </tbody>
                        </table>
                        <!-- Actions -->
                        <div class="table-action-row">
                          <div class="hide-on-mobile">
                            <select class="user-select select-request-action"
                                    [(ngModel)]="demandAction"
                                    name="demand_action">
                              <option value="" disabled hidden>Manage Selection</option>
                              <option value="close">Close Request(s)</option>
                              <option value="delete">Delete Request(s)</option>
                            </select>

                            <button *ngIf="enableDemandApply"
                                    type="button"
                                    class="watersharing-secondary-button post-status-submit"
                                    (click)="applyDemandAction()">
                              Apply
                            </button>

                            <button *ngIf="!enableDemandApply"
                                    type="button"
                                    class="watersharing-secondary-button post-status-submit"
                                    disabled>
                              Apply
                            </button>
                          </div>
                        </div>

                      </form>
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </section>

</main>

<!-- SEND TO TRADING DIALOG -->
<dialog #sendToDialog class="dialog send-to-dialog">
  <header>
    <button type="button" class="dialog-closer dialog-closer-x" (click)="closeDialog()">
      ✖
    </button>
    <h4 class="text-centered">
      Send Info to <span class="send-to-type text-capitalize">{{ dialogType }}</span> Portal
    </h4>
  </header>

  <div class="form-container">
    <p class="dialog-intro">
      Before this request can be sent to the trading portal there are just a couple additional fields you need to review:
    </p>

    <!-- DIALOG FORM -->
    <form (submit)="submitDialog()">

      <!-- DATE RANGE -->
      <div class="watersharing-row">
        <label class="watersharing-form-label spot255">
          <p>Date Range<span class="required">*</span></p>
        </label>

        <div class="watersharing-input-col">
          <div class="watersharing-row columns-grow-w-dash">
            <input type="date" class="form-control" [(ngModel)]="dialog.start_date" name="start_date" required>

            <div class="watersharing-date-sep">—</div>

            <input type="date" class="form-control"
                   [(ngModel)]="dialog.end_date"
                   name="end_date"
                   [disabled]="!dialog.start_date"
                   required>
          </div>
        </div>
      </div>

      <!-- BID TYPE -->
      <div class="watersharing-row">
        <label class="watersharing-form-label spot255"><p>Bid Type<span class="required">*</span></p></label>

        <div class="meta-box-radio">
          <label>
            <input type="radio" name="bid_type" value="Willing to pay"
                   [(ngModel)]="dialog.bid_type" required>
            Willing To Pay
          </label>

          <label>
            <input type="radio" name="bid_type" value="Want to be paid"
                   [(ngModel)]="dialog.bid_type" required>
            Want To Be Paid
          </label>
        </div>
      </div>

      <!-- BID INPUT -->
      <div class="watersharing-row">
        <label class="watersharing-form-label spot255"><p>Bid<span class="required">*</span></p></label>

        <div class="watersharing-input-col">
          <div class="watersharing-row two-col columns-grow">
            <input type="number" placeholder="Bid Amount" min="0" step="0.01"
                   [(ngModel)]="dialog.bid_amount" name="bid_amount"
                   class="form-control" required>

            <select class="user-select"
                    [(ngModel)]="dialog.bid_units"
                    name="bid_units"
                    required>
              <option value="" disabled>–Select–</option>
              <option value="USD/day">USD/day</option>
              <option value="USD/bbl.day">USD/bbl.day</option>
            </select>
          </div>
        </div>
      </div>

      <!-- TRANSPORT SECTION -->

      <div class="watersharing-action-row">
        <button type="button" class="dialog-closer clear-button" (click)="closeDialog()">
          Cancel
        </button>

        <button type="submit" class="watersharing-submit-button create-post-submit-button">
          Add to Trading Portal
        </button>
      </div>

    </form>
  </div>
</dialog>
